import { Routes, RouterModule, ExtraOptions } from '@angular/router';

// services
import { AuthGuard } from './_shared/routeGuards/authGuard';
import { Enums } from './_shared/enums/enums';

// pages
import { LayoutComponent } from './_layout/layout.component';
import { LoginComponent } from './login/login.component';
import { SsoLoginComponent } from './login/ssologin.component';
import { SsoLoginV2Component } from './login/ssologinV2.component';

import { RoutingConfig } from './_config/routing/routing.config';
import { IRoutingConfig } from './_shared/models/models-index';
import { LogoutComponent } from './logout/logout.component';

var routingConfig: IRoutingConfig = new RoutingConfig;
const defaultRoute = routingConfig.routes.find(r => r.default === true);

export const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'ssoLogin', component: SsoLoginComponent },
  { path: 'ssoLoginV2', component: SsoLoginV2Component },
  { path: 'logout', component: LogoutComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: defaultRoute.defaultRoute ?? '/leads/overview'
      }]
  },
  {
    path: 'provider-tools',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: 'Provider Tools',
      breadcrumb: 'Provider Tools',
      allowAnonymous: true
    },
    loadChildren: () => import ('./provider-tools/provider-tools.module').then(m => m.ProviderToolsModule)
  },
  {
    path: 'digAd',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: 'Digital Advertising',
      breadcrumb: 'Digital Advertising',
      allowAnonymous: true
    },
    loadChildren: () => import ('./digitalAdvertising/digad.module').then(m => m.DigAdModule)
  },
  {
    path: 'leads',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    // resolve: [DefaultFilterModelResolver],
    data: {
      title: 'Leads',
      breadcrumb: 'Leads',
      allowAnonymous: true
    },
    loadChildren: () => import ('./leads/leads.module').then(m => m.LeadsModule)
  },
  {
    path: 'inventory',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    // resolve: [DefaultFilterModelResolver],
    data: {
      title: 'Inventory',
      breadcrumb: 'Inventory',
      allowAnonymous: true
    },
    loadChildren: () => import ('./inventory/inventory.module').then(m => m.InventoryModule)
  },
  {
    path: 'dealerResources',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: 'Dealer & Field Resources',
      breadcrumb: 'Dealer & Field Resources',
      allowAnonymous: true,
      hideFilters: true
    },
    loadChildren: () => import('./dealerResources/dealerResources.module').then(m => m.DealerResourcesModule)
  },
  {
    path: 'resources',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: 'Resources',
      breadcrumb: 'Resources',
      allowAnonymous: true,
      hideFilters: true
    },
    loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule)
  },
  {
    path: 'sales',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
    title: 'Sales',
    breadcrumb: 'Sales',
    allowAnonymous: true
    },
    loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule)
  },
  {
    path: 'management',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: 'Management',
      breadcrumb: 'Management',
      roles: ['System Administrator'],
      hideFilters: true
    },
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule)
  },
  {
    path: 'website',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
    title: 'Website',
    breadcrumb: 'Website',
    allowAnonymous: true
    },
    loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule)
  }, {
    path: 'website-performance',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
    title: 'Website',
    breadcrumb: 'Website',
    allowAnonymous: true
    },
    loadChildren: () => import('./hospitality-website/hospitality-website.module').then(m => m.HospitalityWebsiteModule)
  }
];
const extraOptions: ExtraOptions = { enableTracing: false, useHash: false, onSameUrlNavigation: 'reload', relativeLinkResolution: 'corrected' };
export const AppRouter = RouterModule.forRoot(routes, extraOptions);
